import { api } from '../utils/variables';
import axios from 'axios';

const contactApi = axios.create({
  baseURL: api,
});

// Add auth token if available
contactApi.interceptors.request.use(
  config => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Submit feedback/contact form
export const submitFeedback = async (feedbackData) => {
  try {
    const response = await contactApi.post('/api/admin/support/feedback/', feedbackData);
    return response.data;
  } catch (error) {
    console.error('Error submitting feedback:', error);
    throw error;
  }
};

export default contactApi;
